import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useStateContext } from '../contexts/ContextProvider';
import { Header, Button } from '../components';
import DataPreview from '../components/DataPreview';
import AgentComment from '../components/AgentComment';
import LineEDAreviewTrend from './Charts/LineEDAreviewTrend';
import LineEDAratingTrend from './Charts/LineEDAratingTrend';

const DataExploratoryAnalysis = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState('');
  const [unixTime, setUnixTime] = useState('');
  const { currentColor } = useStateContext();
  const [selectedSentimentColors, setSelectedSentimentColors] = useState({
    positive: '#0000FF', // 초기 긍정 색상 (파란색)
    neutral: 'grey', // 초기 중립 색상
    negative: '#FF0000', // 초기 부정 색상 (빨간색)
  });

  useEffect(() => {
    let isMounted = true; // 컴포넌트가 마운트된 상태인지 추적하는 플래그

    const storedUserID = localStorage.getItem('userId');
    const storedUnixTime = localStorage.getItem('unixTime');

    if (isMounted) {
      setUserId(storedUserID || '');
      setUnixTime(storedUnixTime || '');
      console.log(`storedUserID: ${storedUserID}`);
      console.log(`storedUnixTime: ${storedUnixTime}`);
    }

    // 클린업 함수: 컴포넌트가 언마운트될 때 실행되어 상태 업데이트 방지
    return () => {
      isMounted = false;
    };
  }, []); // 컴포넌트가 마운트될 때만 실행

  return (
    <div className="m-2 md:m-10 mt-0 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="데이터탐색(EDA)" title="데이터 원문" />
      <DataPreview previewType={'raw'} />
      <AgentComment
        title="데몽이"
        comment="총 3543개의 데이터, 24.1월~24.10월 까지의 데이터가 있어요. 토스는 금융 플랫폼으로, 사용자 리뷰에서 금융 서비스와 관련된 특수한 패턴을 찾아보는 것이 중요해요. 먼저, 리뷰 내용에서 주요 키워드를 추출해 서비스별로 분류해 보세요. 그런 다음, 평점이 낮은 리뷰에서 자주 언급되는 불만 사항(예: 오류, 처리 속도, 수수료 등)을 파악해 개선점을 도출해 보세요. 반대로, 평점이 높은 리뷰는 강점(예: 사용 편의성, 빠른 처리, 다양한 기능)을 분석해 장점을 확인할 수 있어요. 이러한 분석은 토스의 금융 서비스 특성에 맞춘 인사이트를 제공할 거예요. 분석을 시작해볼까요?"
      /><br/><br/>
      <Header title="리뷰 건수 Trend" />
      <LineEDAreviewTrend />
      <AgentComment
        title="데몽이"
        comment="월별 리뷰 건수는 7월(400건)이 가장 많고 3월(323건)이 가장 적습니다. 계절적 요인이나 이벤트와 관련이 있을 수 있으니 이를 확인해보세요. 월별 평균 리뷰 건수(약 355건)와 분산을 계산해 데이터의 중심 경향과 변동성을 파악하고, 시각화(선 그래프, 막대 그래프)를 통해 흐름을 확인하세요. 또한, 특정 월의 리뷰 증감 원인을 분석하기 위해 마케팅 활동이나 외부 요인을 조사해보는 것도 좋습니다. 리뷰 내용이나 평점 같은 추가 데이터를 결합해 더 깊이 있는 분석을 시도해보세요."
      /><br/><br/>
      <Header title="리뷰 평점 Trend" />
      <LineEDAratingTrend
        colors={[selectedSentimentColors.negative, selectedSentimentColors.neutral, selectedSentimentColors.positive]}
      />
      <AgentComment
        title="데몽이"
        comment="월별 평점 데이터를 분석할 때, 1-2점(부정적 리뷰)의 비율이 7월과 4월에 높아요. 6월은 긍정적 리뷰(4-5점)가 많아서 성공 요인을 파악할 필요가 있어요. 3점은 상대적으로 적은 비중을 차지해요. 부정적 리뷰가 많은 달의 원인을 분석하고, 긍정적 리뷰가 많은 달의 특징을 파악해보세요. 평점 패턴의 변화는 계절적 요인이나 이벤트와 관련이 있을 수 있으니 이를 고려해 분석하세요. 추가 데이터(리뷰 내용, 마케팅 활동)를 결합하면 더 깊이 있는 인사이트를 얻을 수 있어요."
      /><br/><br/>
      <div className="flex justify-end">
        <Button
          color="white"
          bgColor={currentColor}
          text="▶AI 데이터 분류 시작하기"
          borderRadius="10px"
          marginRight="10px"
          onClick={() => navigate('/cls/sentiment/modeling')}
        />
      </div>
    </div>
  );
};

export default DataExploratoryAnalysis;
